const axios = window.axios;

export default {

  async noticeList(page, size){
    const url = `/v1/notices?page=`+page+`&size=`+size+`&sort=regDt%2Cdesc`;
    const response = await axios.get(url);

    return response.data;
  },

  async noticeDetail(seq){
    const url = `/v1/notices/` + seq;
    const response = await axios.get(url);
    return response.data;
  }
}


//https://localhost:8081/v1/notices?page=1&size=20&sort=regDt%2Cdesc
//https://localhost:8081/v1/notice?page=1&size=20&sort=regDt%2Cdesc
